export default __webpack_public_path__ + "static/media/quest_info_page_framed.1e5f7bda.png";